import { gql } from "@apollo/client";

const schema = {
  list: {
    name: 'moduleType',
    serviceName: 'graphql',
    query: gql`
      query moduleType($ids: [String]) {
        moduleType(ids: $ids) {
          data {
            id
            title
          }
          total
          last_page
        }
      }
    `,
  },
};

export default schema;
